import Joi from 'joi';
import { objectSchemaOf } from '../helpers';

export type IReloadParams = {
  consoleId: string;
};

export type IWakeParams = {
  consoleId: string;
};

export type ISleepParams = {
  consoleId: string;
};

export interface IApi {
  systemReloadConsole(param: IReloadParams): Promise<void>;
  systemSleepConsole(param: ISleepParams): Promise<void>;
  systemWakeConsole(param: IWakeParams): Promise<void>;
}

const consoleParamsSchema = objectSchemaOf<{ consoleId: string }>({
  consoleId: Joi.string().required(),
});

export const reloadParamsSchema = consoleParamsSchema;
export const wakeParamsSchema = consoleParamsSchema;
export const sleepParamsSchema = consoleParamsSchema;
